import styled from 'styled-components';
export const StyledIncomeCalculator = styled.div`
  @media screen and (min-width: 1024px) {
    flex-grow: 1;
    flex-basis: 45%;
  }
`;
